import { InjectionToken } from '@angular/core';

export const RECAPTCHA_SITE_KEY = new InjectionToken<string>(
  'RECAPTCHA_SITE_KEY',
  {
    providedIn: 'root',
    factory: () => '',
  },
);

export const RECAPTCHA_ACTIONS = {
  login: 'login',
  sendCode: 'send_code',
} as const;
